import * as React from "react"
import Svg, { Path } from "react-native-svg"

function EditIcon(props: any) {
    return (
        <Svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            {...props}
        >
            <Path
                d="M4.5 19.5h1.1L16.675 8.425l-1.1-1.1L4.5 18.4v1.1zM19.85 7.35l-3.2-3.2L17.7 3.1c.283-.283.637-.421 1.063-.413.424.009.779.155 1.062.438L20.9 4.2c.283.283.425.633.425 1.05 0 .417-.142.767-.425 1.05l-1.05 1.05zM3.75 21a.729.729 0 01-.75-.75V18.1c0-.1.017-.192.05-.275a.76.76 0 01.175-.25L15.6 5.2l3.2 3.2L6.425 20.775a.763.763 0 01-.25.175.735.735 0 01-.275.05H3.75zM16.125 7.875l-.55-.55 1.1 1.1-.55-.55z"
                fill="#80838D"
            />
        </Svg>
    )
}

export default EditIcon
